import { Filter } from "./types";

export const flattenFilters = (filters: Record<string, Filter>): Filter[] => {
  if (!filters) {
    return [];
  }
  return Object.values(filters).flatMap(filter => {
    if (Array.isArray(filter.filterStr)) {
      return filter.filterStr.map(filterStr => ({
        filterStr,
        label: filter.label,
        onclose: filter.onclose ? () => filter.onclose?.(filterStr) : undefined,
        searchKey: filter.searchKey,
        bgColor: filter.bgColor,
      }));
    }
    const filterStr = filter.filterStr;
    if (!filterStr) {
      return [];
    }
    return [
      {
        filterStr,
        label: filter.label,
        onclose: filter.onclose ? () => filter.onclose?.(filterStr) : undefined,
        searchKey: filter.searchKey,
        bgColor: filter.bgColor,
      },
    ];
  });
};

export const getFilterStringByMode = (value: string | null, mode: string) => {
  return value && `${mode === "lt" ? "<" : ">"} ${value}`;
};
